import draught_exclusive from "./draught-exclusive.png";
import fan_favourite from "./fan-favourite.png";
import ireland_exclusive from "./ireland-exclusive.png";
import selling_fast from "./selling-fast.png";
import staff_favourite from "./staff-favourite.png";
import summer_seasonal from "./summer-seasonal.png";
import very_limited from "./very-limited.png";

export default {
  draught_exclusive,
  fan_favourite,
  ireland_exclusive,
  selling_fast,
  staff_favourite,
  summer_seasonal,
  very_limited
};



// WEBPACK FOOTER //
// ./src/components/_common/BeerCard/images/index.js